import { convertDate, monthFormat } from '@/constants/dates';
import { useGetCompletedTestingPlans } from '@/queries/testing-plan.queries';
import { useState } from 'react';
import { CompletedTestPlan, CompletedTests, FirstReducedRisk } from './types';

const groupByMonth = (tests: Array<CompletedTestPlan>) => {
  return tests.reduce<CompletedTests>((acc, test) => {
    const month = convertDate(test.updateAt, monthFormat);

    if (!acc[month]) {
      acc[month] = [test];
    } else {
      acc[month].push(test);
    }

    return acc;
  }, {});
};

export default function useCompletedTestingPlanController() {
  const { data } = useGetCompletedTestingPlans();

  const history = data ?? [];

  const groupedHistory = groupByMonth(history.slice(0, 8));

  const [completedTests, setCompletedTests] = useState(groupedHistory);
  const [showLoadMoreButton, setShowLoadMoreButton] = useState(history.length > 8);

  if (!history.length) {
    return { completedTests: null, firstReducedRisk: null, loadMore: null, showLoadMoreButton: null };
  }

  if (Object.keys(completedTests).length === 0) setCompletedTests(groupedHistory);

  const firstReducedRiskTestIndex = history.findIndex((test) => test?.reducedRisk && test.reducedRisk > 0);
  const firstReducedRiskTest = history[firstReducedRiskTestIndex];
  const firstReducedRisk: FirstReducedRisk =
    firstReducedRiskTestIndex >= 0
      ? {
          month: convertDate(firstReducedRiskTest.updateAt, monthFormat),
          date: firstReducedRiskTest.updateAt,
          type: firstReducedRiskTest.type,
          idType: firstReducedRiskTest.idType,
        }
      : null;

  const loadMore = () => {
    setCompletedTests(groupByMonth(history));
    setShowLoadMoreButton(false);
  };

  return { completedTests, firstReducedRisk, loadMore, showLoadMoreButton };
}
